import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React__default from 'react';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import 'prop-types';
import '../stringSet-b60e9529.js';
function AdminMessage(_ref) {
  var _message$isAdminMessa;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    message = _ref.message;
  if (!(message !== null && message !== void 0 && message.isAdminMessage || message !== null && message !== void 0 && message.messageType) || !(message !== null && message !== void 0 && (_message$isAdminMessa = message.isAdminMessage) !== null && _message$isAdminMessa !== void 0 && _message$isAdminMessa.call(message)) || (message === null || message === void 0 ? void 0 : message.messageType) !== 'admin') {
    return null;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), ['sendbird-admin-message']).join(' ')
  }, /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-admin-message__text",
    type: LabelTypography.CAPTION_2,
    color: LabelColors.ONBACKGROUND_2
  }, message === null || message === void 0 ? void 0 : message.message));
}
export { AdminMessage as default };